import "@/App.css";
import { Toaster } from "@/components/ui/sonner";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Services from "@/components/Services";
import Industries from "@/components/Industries";
import WhyAci from "@/components/WhyAci";
import QuoteForm from "@/components/QuoteForm";
import Footer from "@/components/Footer";

function App() {
  return (
    <div className="App grain">
      <Header />
      <main>
        <Hero />
        <Marquee />
        <Services />
        <Industries />
        <WhyAci />
        <QuoteForm />
      </main>
      <Footer />
      <Toaster position="top-center" theme="dark" />
    </div>
  );
}

export default App;
